module.exports = __webpack_public_path__ + "static/blue_dragon-74d5a541e46055b404a376bcabcbd2d2.jpg";